import { IconCrown } from "@tabler/icons"
import { ModalBody, UtilityModal } from "../../../../components"
import { trialEndModalForMembers } from "../../../../utils"

const UpgradeModal = ({
  isSiteOwner = false,
}) => {
  return UtilityModal({
    id: 'saved-templates-upgrade-modal',
    body: (props) =>
      <ModalBody
        action='warning'
        title='Saved Templates are premium feature'
        description="Please upgrade to a higher plan to access this feature."
        handleClose={props.handleClose}
        icon={<IconCrown />}
        buttons={[{ label:"Upgrade",  onClick: () => isSiteOwner ? window.pricing?.show() : trialEndModalForMembers(), reactIntlId: "global.button.upgrade" }]}
      />
  })
}

export default UpgradeModal